import StaticMap from './StaticMap'

export default StaticMap
